import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const deleteTransactionContract = c.router(
    {
        softDeleteTransaction: {
            method: "DELETE",
            path: "/soft/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
        restoreTransaction: {
            method: "POST",
            path: "/restore/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            body: null,
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
        hardDeleteTransaction: {
            method: "DELETE",
            path: "/hard/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
    },
    {
        pathPrefix: "/delete-transaction",
    },
);
